import { render, staticRenderFns } from "./flight.vue?vue&type=template&id=a2b16a02&"
import script from "./flight.vue?vue&type=script&lang=ts&"
export * from "./flight.vue?vue&type=script&lang=ts&"
import style0 from "./flight.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports